export const SWITCHER_STYLES = {
  MODAL_CONTAINER: 'w-[420px] rounded-[12px] shadow-light bg-bw00 flex flex-col',
  HEADER_WRAPPER: 'py-[20px] px-[24px] flex items-center justify-between border-b border-bw03',
  HEADER_TITLE: 'font-metricR text-[18px] text-bw08',
  BODY_WRAPPER: 'flex flex-col w-full px-[8px] pt-[4px]',
  FOOTER_WRAPPER: 'px-[8px] pb-[8px]',
  FOOTER_BODY: 'flex items-center px-[16px] py-[16px] rounded-[4px] hover:bg-bw02 gap-[8px]',
  FOOTER_TITLE: 'font-metricR text-[16px] text-action03',
  LOADER_MODAL_WRAPPER: 'bg-bw01 flex justify-center fixed inset-0 h-screen w-screen z-[99999]',
  LOADER_ICON_RIGHT: 'absolute top-0 right-0 translate-x-[8px] translate-y-[-15px]',
  LOADER_ICON_LEFT: 'absolute bottom-0 left-0 translate-x-[-8px] translate-y-[15px]',
  LOADER_TITLE: 'font-metricR text-[18px] text-bw08',
  LOADER_LILI_ICON: 'w-[60px] mt-[150px]',
  LOADER_PROFILE: 'rounded-[50%] w-[52px] h-[52px] flex items-center justify-center relative',
  ACCOUNT_STRIP_BUTTON: 'w-full hover:cursor-pointer',
  STRIP_PROFILE: 'rounded-[50%] w-[40px] h-[40px] flex items-center justify-center relative',
  CHILDREN_CONTAINER: 'flex items-center justify-between px-[16px] py-[16px] rounded-[4px] hover:bg-bw02',
  CHILDREN_LEFT_CONTAINER: 'flex items-center gap-[8px]',
  ACCOUNT_NAME: 'font-metricRMedium max-w-[260px] truncate text-[16px] text-bw08',
  ACCOUNT_EIN: 'font-metricR text-[14px] text-bw06',
  FLEX_COL_START: 'flex flex-col items-baseline',
};
